import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Portrait from '../assets/Portrait.png';

const ScrollReveal = ({ children, className = "" }) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const currentRef = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.1 }
        );
        if (currentRef) observer.observe(currentRef);
        return () => {
            if (currentRef) observer.unobserve(currentRef);
        };
    }, []);

    return (
        <div ref={ref} className={`transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'} ${className}`}>
            {children}
        </div>
    );
};

const Home = () => {
    return (
        <main>
            <section className="relative min-h-screen flex items-center pt-24 overflow-hidden bg-grid-subtle">
                <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-b from-transparent via-background-dark/50 to-background-dark z-10"></div>
                <div className="absolute -right-20 top-1/2 -translate-y-1/2 opacity-[0.03] select-none pointer-events-none">
                    <h2 className="text-[400px] font-black sports-font leading-none">BUILD</h2>
                </div>
                <div className="max-w-[1400px] mx-auto px-8 w-full relative z-20">
                    <div className="grid lg:grid-cols-12 gap-12 items-center">
                        <div className="lg:col-span-8">
                            <div className="inline-flex items-center gap-3 px-4 py-1.5 bg-primary/10 border border-primary/20 text-primary mb-8">
                                <span className="w-1.5 h-1.5 rounded-full bg-primary"></span>
                                <span className="text-[11px] font-bold uppercase tracking-[0.3em]">Available for work</span>
                            </div>
                            <h1 className="text-white text-7xl md:text-9xl lg:text-[140px] font-black sports-font mb-10 text-glitch animate-fade-in-up">
                                TAVEN<br />
                                HARRIS<span className="text-primary">_</span>
                            </h1>
                            {/*<p className="text-white/60 text-xl md:text-2xl max-w-2xl font-light leading-relaxed mb-12 animate-fade-in-up" style={{ animationDelay: '0.2s', opacity: 0, animationFillMode: 'forwards' }}>*/}
                            {/*    I engineer <span className="text-white font-semibold">robust, data-driven systems</span>. Specialized in full-stack development, ML integration, and scalable automated analytics.*/}
                            {/*</p>*/}
                            <div className="flex flex-wrap gap-6 animate-fade-in-up" style={{ animationDelay: '0.4s', opacity: 0, animationFillMode: 'forwards' }}>
                                <Link to="/portfolio" className="bg-primary hover:bg-white text-black px-10 py-5 font-black uppercase text-sm tracking-widest flex items-center gap-4 transition-all hover:-translate-y-1">
                                    Explore Projects
                                    <span className="material-symbols-outlined text-lg">arrow_outward</span>
                                </Link>
                                <Link to="/stack" className="bg-white/5 hover:bg-white/10 border border-white/10 text-white px-10 py-5 font-black uppercase text-sm tracking-widest flex items-center gap-4 transition-all">
                                    Technical Stack
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[40%] h-[85%] hidden lg:block z-0 opacity-60">
                    <div
                        className="aspect-[4/5] bg-cover bg-center grayscale brightness-75 border-r-[12px] border-primary"
                        style={{
                            backgroundImage: `url(${Portrait})`,
                            maskImage: 'linear-gradient(to bottom, black 90%, transparent 100%)',
                            WebkitMaskImage: 'linear-gradient(to bottom, black 90%, transparent 100%)'
                        }}
                    ></div>
                </div>
            </section>

            <section className="border-y border-white/10 bg-surface-dark/30 backdrop-blur-sm relative z-20">
                <div className="max-w-[1400px] mx-auto px-8">
                    <div className="grid grid-cols-2 md:grid-cols-4 py-12 gap-12">
                        <div className="group flex flex-col items-center text-center">
                            <p className="text-white/40 text-[10px] font-bold uppercase tracking-[0.3em] mb-2 group-hover:text-primary transition-colors">Class of</p>
                            <div className="flex items-baseline gap-2">
                                <span className="text-5xl font-black sports-font">2027</span>
                                <span className="text-primary font-bold text-sm">GRAD</span>
                            </div>
                        </div>
                        <div className="group flex flex-col items-center text-center">
                            <p className="text-white/40 text-[10px] font-bold uppercase tracking-[0.3em] mb-2 group-hover:text-primary transition-colors">Experience</p>
                            <div className="flex items-baseline gap-2">
                                <span className="text-5xl font-black sports-font">3+</span>
                                <span className="text-primary font-bold text-sm">ROLES</span>
                            </div>
                        </div>
                        <div className="group flex flex-col items-center text-center">
                            <p className="text-white/40 text-[10px] font-bold uppercase tracking-[0.3em] mb-2 group-hover:text-primary transition-colors">Tech Stack</p>
                            <div className="flex items-baseline gap-2">
                                <span className="text-5xl font-black sports-font">10+</span>
                                <span className="text-primary font-bold text-sm">TOOLS</span>
                            </div>
                        </div>
                        <div className="group flex flex-col items-center text-center">
                            <p className="text-white/40 text-[10px] font-bold uppercase tracking-[0.3em] mb-2 group-hover:text-primary transition-colors">Projects</p>
                            <div className="flex items-baseline gap-2">
                                <span className="text-5xl font-black sports-font">5+</span>
                                <span className="text-primary font-bold text-sm">MAJOR</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-32 bg-background-dark relative overflow-hidden">
                <div className="max-w-[1400px] mx-auto px-8 relative z-20">
                    <ScrollReveal>
                        <div className="grid lg:grid-cols-2 gap-24 items-start">
                            <div>
                                <div className="flex items-center gap-4 mb-8">
                                    <span className="w-12 h-[2px] bg-primary"></span>
                                    <span className="text-primary font-bold uppercase tracking-[0.4em] text-xs">The Goal</span>
                                </div>
                                <h2 className="text-5xl md:text-7xl font-black sports-font text-white mb-12">
                                    ABOUT <br /><span className="text-primary">ME</span>
                                </h2>
                                <div className="space-y-8 text-white/70 text-lg leading-relaxed max-w-xl">
                                    <p>
                                        I’m a computer science student focused on building end-to-end systems that blend software, hardware, and AI — from full-stack web apps and data automation to robotics and real-world deployed tools.
                                    </p>
                                    <p>
                                        I build complete, working systems that connect ideas to reality.
                                    </p>
                                </div>
                                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                                    <div className="p-6 bg-surface-dark border border-white/5">
                                        <span className="material-symbols-outlined text-primary mb-4 text-3xl">data_object</span>
                                        <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-2">Backend & Data</h4>
                                        <p className="text-white/40 text-xs leading-relaxed">Python, Docker, REST APIs, IT Analytics, and Automation.</p>
                                    </div>
                                    <div className="p-6 bg-surface-dark border border-white/5">
                                        <span className="material-symbols-outlined text-primary mb-4 text-3xl">devices</span>
                                        <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-2">Frontend & App</h4>
                                        <p className="text-white/40 text-xs leading-relaxed">React.js, Flutter, Interactive UIs, and Mobile Development.</p>
                                    </div>
                                    <div className="p-6 bg-surface-dark border border-white/5">
                                        <div className="text-3xl font-black sports-font text-primary mb-4">CS</div>
                                        <p className="text-white/90 font-bold uppercase tracking-widest text-sm mb-2">Santa Clara University</p>
                                        <p className="text-white/40 text-xs leading-relaxed italic">"Developing next-gen solutions with a focus on automation, analytics, and user experience."</p>
                                    </div>
                                </div>
                            </div>

                            {/* Keep grid structure, but hide the "column" on large since image becomes a background panel */}
                            <div className="hidden lg:block" />
                        </div>
                    </ScrollReveal>
                </div>

                {/* Background image panel (big, right side) */}
                <div className="absolute right-0 top-0 h-full w-[46%] hidden lg:block z-0 opacity-60 pointer-events-none">
                    <div
                        className="h-full w-full bg-cover bg-center grayscale brightness-75 border-r-[12px] border-primary"
                        style={{
                            backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuCnKBhWUNWX9vNiGRtkXc13fZ6qcvJtXJRdCFcwqd79_lm_mrwdV_uIgJN9Tn_gbxa5dPY2E87tQZ0mMy_qpUDzBBol3uUYxJd_GnjPek50WCJ4HYIK-BGrxcio-sfzu8VWOtCIBHOoR6M-_CdtvtW0WIkFWxZ8PMyv4iXaF-JhvdUc-6PJP5UF9cHqogaM-QblggYkXRRKYox0XyccMgPe-KxAjecUXC6FV6PSTmy5Szgo27WIEF9jCE-bPP_ooombIYFQ56cv-rI")',
                            maskImage: 'linear-gradient(to left, black 75%, transparent 100%)',
                            WebkitMaskImage: 'linear-gradient(to left, black 75%, transparent 100%)'
                        }}
                    ></div>

                    <div className="absolute -top-6 -right-6 w-32 h-32 border-t-2 border-r-2 border-primary/30"></div>
                </div>

                {/* Darken/soften the image, but keep it UNDER the text */}
                <div className="absolute inset-0 bg-gradient-to-r from-background-dark via-background-dark/80 to-transparent pointer-events-none z-10 hidden lg:block"></div>
            </section>

            <section className="py-24 bg-surface-dark border-y border-white/5">
                <div className="max-w-[1400px] mx-auto px-8">
                    <ScrollReveal>
                        <div className="grid md:grid-cols-3 gap-px bg-white/5 border border-white/5">
                            <div className="bg-background-dark p-16 group hover:bg-surface-dark transition-colors">
                                <span className="text-primary font-black sports-font text-2xl mb-8 block">01</span>
                                <h3 className="text-2xl font-black sports-font text-white mb-6 group-hover:text-primary">Performance First</h3>
                                <p className="text-white/50 text-sm leading-relaxed mb-8">Optimizing the critical path. My builds are lean, fast, and engineered for sub-second response times across the globe.</p>
                                <div className="h-1 w-0 bg-primary group-hover:w-full transition-all duration-500"></div>
                            </div>
                            <div className="bg-background-dark p-16 group hover:bg-surface-dark transition-colors">
                                <span className="text-primary font-black sports-font text-2xl mb-8 block">02</span>
                                <h3 className="text-2xl font-black sports-font text-white mb-6 group-hover:text-primary">Scalable Design</h3>
                                <p className="text-white/50 text-sm leading-relaxed mb-8">Building systems that grow. Modular architecture that handles 10 users or 10 million without breaking a sweat.</p>
                                <div className="h-1 w-0 bg-primary group-hover:w-full transition-all duration-500"></div>
                            </div>
                            <div className="bg-background-dark p-16 group hover:bg-surface-dark transition-colors">
                                <span className="text-primary font-black sports-font text-2xl mb-8 block">03</span>
                                <h3 className="text-2xl font-black sports-font text-white mb-6 group-hover:text-primary">Visual Impact</h3>
                                <p className="text-white/50 text-sm leading-relaxed mb-8">Bold, functional aesthetics. I believe software should look as powerful as the logic that drives it.</p>
                                <div className="h-1 w-0 bg-primary group-hover:w-full transition-all duration-500"></div>
                            </div>
                        </div>
                    </ScrollReveal>
                </div>
            </section>
        </main>
    );
};

export default Home;
